import { useIntl } from 'react-intl'

import {
  Button,
  Flex,
  FlexItem,
  FormElement,
  Grid,
  GridCell,
  INPUT_NUMBER_VARIANT_DANGER,
  INPUT_TEXT_VARIANT_DANGER,
  InputNumber,
  InputText,
  Link,
  LINK_VARIANT_EXTRALIGHT,
  Panel,
  RadioButton,
  RADIOBUTTON_LABEL_FW_STANDARD,
  Select,
  SPACING_16,
  SpacingVertical,
  Text,
  Title,
  TITLE_VARIANT_S
} from 'mailup-web-components'

import { useRecoilCallback, useRecoilValue, useSetRecoilState } from 'recoil'
import { campaignState } from '../../recoil/state/campaign'
import { sourceListState, step1EnabledState } from '../../recoil/state/page'

import { evalCondition } from 'mailup-react-helpers'
import { modalNewSourceState } from 'Pages/Campaign/recoil/state/modals'
import { saveCampaignCallback } from '../../recoil/callbacks/callbacks'

const Step1 = () => {
  const intl = useIntl()
  const {
    Name,
    nameIsDiry,
    IdSource,
    idSouceIsDirty,
    EmailOptions,
    ShowNumberOfContents,
    showNumberOfContentsIsDirty
  } = useRecoilValue(campaignState)
  const setCampaignState = useSetRecoilState(campaignState)
  const { sourceList } = useRecoilValue(sourceListState)
  const step1Enabled = useRecoilValue(step1EnabledState)
  const isSourceEnabled = evalCondition('uo:CONTENTSSOURCES')
  const setModalNewSource = useSetRecoilState(modalNewSourceState)
  const saveCampaign = useRecoilCallback(saveCampaignCallback, [])

  const onChangeName = (e) => {
    setCampaignState((prev) => ({
      ...prev,
      Name: e.target.value,
      nameIsDiry: true,
      isDirty: true
    }))
  }

  const handleChangeSource = (val) => {
    setCampaignState((prev) => ({
      ...prev,
      IdSource: val,
      idSouceIsDirty: true,
      isDirty: true
    }))
  }

  const handleChangeSubjectType = (event) => {
    setCampaignState((prev) => ({
      ...prev,
      isDirty: true,
      EmailOptions: {
        ...prev.EmailOptions,
        SubjectType: parseInt(event.target.value)
      }
    }))
  }

  const onChangeSubject = (event) => {
    setCampaignState((prev) => ({
      ...prev,
      isDirty: true,
      EmailOptions: {
        ...prev.EmailOptions,
        Subject: event.target.value,
        subjectIsDirty: true
      }
    }))
  }

  const onChangeShowNumberOfContents = (val) => {
    setCampaignState((prev) => ({
      ...prev,
      ShowNumberOfContents: val,
      showNumberOfContentsIsDirty: true,
      isDirty: true
    }))
  }

  const AddSourceLink = () => (
    <>
      {isSourceEnabled ? (
        <Link variant={LINK_VARIANT_EXTRALIGHT} onClick={handleAddSource}>
          {intl.formatMessage({
            id: 'Load.ContentsCampaignWizard.AggiungiNuovaSorgente'
          })}
        </Link>
      ) : undefined}
    </>
  )

  const handleAddSource = () => {
    setModalNewSource((prev) => ({
      ...prev,
      show: true
    }))
  }

  return (
    <>
      <Panel>
        <Grid>
          <GridCell>
            <FormElement
              label={intl.formatMessage({
                id: 'Load.ContentsCampaignWizard.NomeCampagna'
              })}
              required
              feedback={
                !Name && nameIsDiry
                  ? intl.formatMessage({ id: 'Load.MailupCommon.Required' })
                  : null
              }
              feedbackVariant={!Name && nameIsDiry ? 'danger' : null}
            >
              <InputText
                placeholder={intl.formatMessage({
                  id: 'Load.ContentsCampaignWizard.CampaignNamePlaceholder'
                })}
                onChange={onChangeName}
                value={Name}
                data-mu-test='campaign__input-name'
                maxLength='128'
                variant={!Name && nameIsDiry ? INPUT_TEXT_VARIANT_DANGER : null}
              />
            </FormElement>
          </GridCell>
          <GridCell>
            <FormElement
              label={intl.formatMessage({
                id: 'Load.ContentsCampaignWizard.SelezionaSorgente'
              })}
              required
              hint={intl.formatMessage({
                id: 'Load.ContentsCampaignWizard.SelezionaSorgenteTips'
              })}
              feedback={
                !IdSource && idSouceIsDirty
                  ? intl.formatMessage({ id: 'Load.MailupCommon.Required' })
                  : null
              }
              feedbackVariant={IdSource && idSouceIsDirty ? 'danger' : null}
              LabelRightComponent={AddSourceLink}
            >
              <Select
                searchable
                value={IdSource}
                options={sourceList}
                onChange={handleChangeSource}
                data-mu-test='campaign__select-source'
                error={!IdSource && idSouceIsDirty}
                placeholder={intl.formatMessage({
                  id: 'Load.ContentsCampaignWizard.SelectSource'
                })}
              />
            </FormElement>
          </GridCell>
        </Grid>
      </Panel>
      <Panel>
        <FormElement
          label={intl.formatMessage({
            id: 'Load.Common.Subject'
          })}
          required
        >
          <SpacingVertical />
          <Flex flexDirection='column'>
            <RadioButton
              labelVariant={RADIOBUTTON_LABEL_FW_STANDARD}
              label={intl.formatMessage({
                id: 'Load.ContentsCampaignWizard.OggettoPrimoFeed'
              })}
              checked={EmailOptions.SubjectType === 1}
              value={1}
              onChange={handleChangeSubjectType}
              data-mu-test='campaign-wizard__step-1__radio-button__first-feed'
            />
            <SpacingVertical />
            <RadioButton
              labelVariant={RADIOBUTTON_LABEL_FW_STANDARD}
              label={intl.formatMessage({
                id: 'Load.ContentsCampaignWizard.OggettoPrimiTreFeed'
              })}
              checked={EmailOptions.SubjectType === 2}
              value={2}
              onChange={handleChangeSubjectType}
              data-mu-test='campaign-wizard__step-1__radio-button__three-feed'
            />
            <SpacingVertical variant={SPACING_16} />
            <FlexItem>
              <Flex alignItems='baseline'>
                <RadioButton
                  labelVariant={RADIOBUTTON_LABEL_FW_STANDARD}
                  label={intl.formatMessage({
                    id: 'Load.ContentsCampaignWizard.OggettoTestoFisso'
                  })}
                  checked={EmailOptions.SubjectType === 3}
                  value={3}
                  onChange={handleChangeSubjectType}
                  data-mu-test='campaign-wizard__step-1__radio-button__fixed'
                />
                <FlexItem width='50%'>
                  <FormElement
                    feedback={
                      !EmailOptions.Subject &&
                      EmailOptions.subjectIsDirty &&
                      EmailOptions.SubjectType === 3
                        ? intl.formatMessage({
                            id: 'Load.MailupCommon.Required'
                          })
                        : null
                    }
                    feedbackVariant={
                      !EmailOptions.Subject &&
                      EmailOptions.subjectIsDirty &&
                      EmailOptions.SubjectType === 3
                        ? 'danger'
                        : null
                    }
                  >
                    <InputText
                      placeholder={intl.formatMessage({
                        id: 'Load.ContentsCampaignWizard.CampaignSubjetPlaceholder'
                      })}
                      onChange={onChangeSubject}
                      value={EmailOptions.Subject}
                      data-mu-test='input-Subject'
                      disabled={EmailOptions.SubjectType !== 3}
                      variant={
                        !EmailOptions.Subject &&
                        EmailOptions.subjectIsDirty &&
                        EmailOptions.SubjectType === 3
                          ? INPUT_TEXT_VARIANT_DANGER
                          : ''
                      }
                    />
                  </FormElement>
                </FlexItem>
              </Flex>
            </FlexItem>
          </Flex>
        </FormElement>
        <SpacingVertical variant='32' />
        <Title variant={TITLE_VARIANT_S}>
          {intl.formatMessage({
            id: 'Load.ContentsCampaignWizard.CorpoMessaggioLabel'
          })}{' '}
          *
        </Title>
        <SpacingVertical variant={SPACING_16} />
        <Flex alignItems='baseline' justifyContent='flex-start' columnGap='8px'>
          <Text>
            {intl.formatMessage({
              id: 'Load.ContentsCampaignWizard.NumeroArticoli'
            })}
          </Text>
          <FormElement
            feedback={
              !ShowNumberOfContents && showNumberOfContentsIsDirty
                ? intl.formatMessage({ id: 'Load.MailupCommon.Required' })
                : null
            }
          >
            <FlexItem width='90px'>
              <InputNumber
                min={1}
                max={1000}
                onChange={onChangeShowNumberOfContents}
                value={ShowNumberOfContents}
                data-mu-test='input-ShowNumberOfContents'
                variant={
                  !ShowNumberOfContents && showNumberOfContentsIsDirty
                    ? INPUT_NUMBER_VARIANT_DANGER
                    : ''
                }
              />
            </FlexItem>
          </FormElement>
        </Flex>
      </Panel>
      <Button
        onClick={() => saveCampaign(2)}
        kind='primary'
        disabled={!step1Enabled}
        data-mu-test='campaign-wizard__step-1__save-button'
      >
        {intl.formatMessage({ id: 'Load.Common.Next' })}
      </Button>
    </>
  )
}

export default Step1
